module.exports = __webpack_public_path__ + "static/media/26.69ebd953.jpg";